//@flow

import * as React from 'react';
import styled from 'styled-components';

const StyledBackground = styled.img`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    z-index: -1;
`;

const ImageBackground = (props: any): React.Node  => (
  <StyledBackground src={props.src} {...props} />
);

export default ImageBackground;



// WEBPACK FOOTER //
// ./src/components/background/ImageBackground.jsx